import { TranslateService } from './../../shared/translate/translate.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from "../../shared/models/auth.service";

@Component({
  selector: 'wego-gadmin',
  template: `
  <div class="admin-role">
    <div [class]="toggleClass" (window:resize)="onResize($event)" >
      <wego-navbar (toggleMenu)="ToggleMenuLocal()"></wego-navbar>
      <wego-sidebar [menu]="menu"></wego-sidebar>
      <wego-content-wrapper></wego-content-wrapper>
      <wego-footer></wego-footer>
    </div>
  </div>
  `,
})

export class GAdminComponent implements OnInit, OnDestroy {
  toggleClass: string = "ui-skins sidebar-mini";
  menu: any = [
    // {
    //   title: 'LblDashboard',
    //   icon: 'fa fa-tachometer fa-fw',
    //   redirectPath: 'dashboard',
    // },
    // {
    //   title: 'LblSharedVehicleGroups',
    //   icon: 'fa fa-group fa-fw',
    //   redirectPath: 'sharedvehiclegroup/list',
    //   items: [{
    //     title: 'LblSharedVehicleGroupOverview',
    //     icon: '',
    //     redirectPath: 'sharedvehiclegroup/list',
    //   },
    //   {
    //     title: 'LblOdometerLogTrail',
    //     icon: '',
    //     redirectPath: 'odometerlogtrail/list',
    //   }]
    // },
    // {
    //   title: 'LblDrivers',
    //   icon: 'fa fa-male fa-fw',
    //   redirectPath: 'driver/list',
    // },
    // {
    //   title: 'LblBookings',
    //   icon: 'fa fa-calendar fa-fw',
    //   redirectPath: 'booking',
    //   items: [
    //     {
    //       title: 'LblBookingsOverview',
    //       icon: '',
    //       redirectPath: 'booking/overview',
    //     },
    //     {
    //       title: 'LblNormal',
    //       icon: '',
    //       redirectPath: 'booking',
    //     },
    //     {
    //       title: 'LblSpecial',
    //       icon: '',
    //       redirectPath: 'specialbooking',
    //     }
    //   ]
    // },
    // {
    //   title: 'LblInvoicing',
    //   icon: 'fa fa-file-text fa-fw',
    //   redirectPath: 'invoice',
    //   items: [{
    //     title: 'LblAdditionalFreeItemsMenu',
    //     icon: '',
    //     redirectPath: 'additionalfreeitem/list',
    //   }]
    // }, {

    //   title: 'LblReports',
    //   icon: 'fa fa-file-o fa-fw',
    //   redirectPath: '',
    //   items: [
    //     {
    //       title: 'LblVehicleOccupancyReport',
    //       icon: '',
    //       redirectPath: 'report/vehicleoccupancy',
    //     },
    //     {
    //       title: 'LblRevenuePerVehicleReport',
    //       icon: '',
    //       redirectPath: 'report/revenuepervehiclereport',
    //     },
    //     {
    //       title: 'LblTripDataReport',
    //       icon: '',
    //       redirectPath: 'tripdatareport/tripdatareport',
    //     }, {
    //       title: 'LblMaintenancePlanningreport',
    //       icon: '',
    //       redirectPath: 'report/maintenanceplanningreport',
    //     }]},
    // {
    //   title: 'LblSignupForms',
    //   icon: 'fa fa-pencil-square-o fa-fw',
    //   redirectPath: 'signupform/list',
    //   items: [
    //     {
    //       title: 'LblSignupsOverView',
    //       icon: '',
    //       redirectPath: 'signup/list',
    //     }]
    // },
  ];

  constructor(private translate: TranslateService,
    private authService: AuthService) { }
  ngOnInit() {
    this.translate.setDetectedLang();
    this.authService.GetBackOfficeMenu().subscribe(
      res => {
        this.menu= res.data;
      },
      error => {
      });
  }

  public ToggleMenuLocal() {
    if (window.innerWidth > 767) {
      if (this.toggleClass == "ui-skins sidebar-mini")
        this.toggleClass = "ui-skins sidebar-mini sidebar-collapse";
      else if (this.toggleClass == "ui-skins sidebar-mini sidebar-collapse" || this.toggleClass == "ui-skins sidebar-mini sidebar-open")
        this.toggleClass = "ui-skins sidebar-mini";
    }
    else {
      if (this.toggleClass == "ui-skins sidebar-mini")
        this.toggleClass = "ui-skins sidebar-mini sidebar-open";
      else if (this.toggleClass == "ui-skins sidebar-mini sidebar-open" || this.toggleClass == "ui-skins sidebar-mini sidebar-collapse")
        this.toggleClass = "ui-skins sidebar-mini";
    }
  }

  onResize(event: any) {
  }

  ngOnDestroy() { }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/role/components/gadmin.component.ts